import {
  List,
  Datagrid,
  TextField,
  BooleanField,
  NumberField,
  EditButton,
  DeleteButton,
  TopToolbar,
  CreateButton,
  ExportButton,
  FilterButton,
  SearchInput,
  BooleanInput,
  Filter,
} from 'react-admin';

const CaseCategoryFilter = (props: any) => (
  <Filter {...props}>
    <SearchInput source="q" alwaysOn />
    <BooleanInput source="isActive" />
  </Filter>
);

const CaseCategoryListActions = () => (
  <TopToolbar>
    <FilterButton />
    <CreateButton />
    <ExportButton />
  </TopToolbar>
);

export const CaseCategoryList = () => (
  <List
    filters={<CaseCategoryFilter />}
    actions={<CaseCategoryListActions />}
    sort={{ field: 'sortOrder', order: 'ASC' }}
    perPage={25}
  >
    <Datagrid rowClick="show">
      <TextField source="name" />
      <TextField source="slug" />
      <BooleanField source="isActive" />
      <NumberField source="sortOrder" />
      <NumberField source="_count.cases" />
      <EditButton />
      <DeleteButton mutationMode="pessimistic" />
    </Datagrid>
  </List>
);
